import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { lineItemStatuses as shipmentLineItemStatuses } from '@/parcels/constants'
import { statuses as returnLineItemStatuses } from '@/returns/constants'

import ValidationSummaryLine from './ValidationSummaryLine/ValidationSummaryLine'
import { getLineItemsByStatus } from './helpers'
import * as Styles from './styles'

const ValidationSummary = ({ lineItems, showTitle }) => {
  const { t } = useTranslation()

  //for return line items:
  const inProgressLineItems = getLineItemsByStatus(lineItems, returnLineItemStatuses.inProgress)
  const acceptedLineItems = getLineItemsByStatus(lineItems, returnLineItemStatuses.accepted)
  const rejectedLineItems = getLineItemsByStatus(lineItems, returnLineItemStatuses.rejected)
  const forReviewLineItems = getLineItemsByStatus(lineItems, returnLineItemStatuses.forReview)

  //for shipment line items:
  const packedLineItems = getLineItemsByStatus(lineItems, shipmentLineItemStatuses.packed)
  const pendingLineItems = getLineItemsByStatus(lineItems, shipmentLineItemStatuses.pending)
  const discardedLineItems = getLineItemsByStatus(lineItems, shipmentLineItemStatuses.discarded)

  return (
    <Styles.MainContainer>
      {showTitle && <Text type="titleS">{t('La transacción quedará así')}:</Text>}
      {/* return line items */}
      <ValidationSummaryLine count={inProgressLineItems?.length} type={returnLineItemStatuses.inProgress} />
      <ValidationSummaryLine count={acceptedLineItems?.length} type={returnLineItemStatuses.accepted} />
      <ValidationSummaryLine count={rejectedLineItems?.length} type={returnLineItemStatuses.rejected} />
      <ValidationSummaryLine count={forReviewLineItems?.length} type={returnLineItemStatuses.forReview} />
      {/* shipment line items */}
      <ValidationSummaryLine count={pendingLineItems?.length} type={shipmentLineItemStatuses.pending} />
      <ValidationSummaryLine count={packedLineItems?.length} type={shipmentLineItemStatuses.packed} />
      <ValidationSummaryLine count={discardedLineItems?.length} type={shipmentLineItemStatuses.discarded} />
    </Styles.MainContainer>
  )
}

export default ValidationSummary
